export default "__VITE_ASSET__2ba9e2b7__"